export default __webpack_public_path__ + "static/media/1796.711d599f.png";